import { RouletteScene } from '../scenes/RouletteScene';
import { BetManager } from '../ui/BetManager';

export class ResetManager {
	private scene: RouletteScene;
	private betManager: BetManager;

	constructor(scene: RouletteScene, betManager: BetManager) {
		this.scene = scene;
		this.betManager = betManager;
	}

	// Função para resetar todas as apostas e restaurar a quantidade inicial de fichas com efeito de fade out
	public resetAllBets() {
		// Limpa as apostas registradas no ChipManager
		this.betManager.clearBets(true);
		// Clear history
		this.scene.history = [];

		// Remover todas as fichas colocadas no mapa com efeito de fade out
		this.scene.placedChipsMap.forEach((chipContainer, number) => {
			if (chipContainer) {
				// Aplica o efeito de fade out nas fichas antes de removê-las
				this.scene.tweens.add({
					targets: chipContainer,
					alpha: 0, // Efeito de fade out
					duration: 500, // Duração do fade out
					onComplete: () => {
						// Após o fade out, destruir o container da ficha
						chipContainer.destroy();
					}
				});
			}
		});

		// Limpa o mapa de fichas colocadas após remover todas
		this.scene.placedChipsMap.clear();

		console.log('Apostas removidas e fichas restauradas com efeito de fade out.');
	}
}
